export const FontFamily = "'Lucida Sans'"

export const COLORS = {
  info: {
    dark: '#0084F4',
    medium: '#4EAEFF',
    light: '#A6D6FF',
  },
  danger: {
    dark: '#FF4949',
    medium: '#FF9999',
    light: '#FDC7C7',
  },
  success: {
    dark: '#13CE66',
    medium: '#6CCA95',
    light: '#CEE3D7',
  },
  warning: {
    dark: '#FFC82C',
    medium: '#FFDD7D',
    light: '#FFEDB9',
  },
}

export const Device = {
  mobileS: 320,
  mobileM: 411,
  tableS: 600,
  tableM: 768,
  tableL: 1024,
  laptop: 1198,
  desktopS: 1280,
  desktop: 1366,
}
